// import { cloneDeep } from "lodash";
import ApiService from "@/core/services/api.service";
import ObjPath from "object-path";

// Action types
export const SET_SUPPLIER = "setSelectionSupplier";
export const SET_SUPPLIER_DATA = "setSelectionSupplierData";
export const SET_SUPPLIER_PROPERTY = "setSelectionSupplierProperty";
export const SET_SUPPLIER_PROPERTY_CONTACT =
  "setSelectionSupplierPropertyContact";
export const SET_SUPPLIER_BILLING = "setSelectionSupplierBilling";
export const SET_SUPPLIER_BILLING_CONTACT =
  "setSelectionSupplierBillingContact";
export const SET_LOADING = "setSupplierSelectionLoading";
export const CLEAR_SUPPLIER = "clearSupplier";
export const GET_SUPPLIER_RELATED = "getSupplierRelated";
export const SET_SUPPLIER_RELATED = "setSupplierRelated";
export const SET_DIALOG_STATUS = "setSupplierDialogStatus";
export const SET_CREATE_DIALOG_STATUS = "setSupplierCreateDialogStatus";

export default {
  state: {
    db_dialog: false,
    db_create_dialog: false,
    db_selection_loading: false,
    db_selection_supplier: {},
    db_selection_supplier_property: {},
    db_selection_supplier_property_contact: {},
    db_selection_supplier_billing: {},
    db_selection_supplier_billing_contact: {},
    db_ctx_related_invoices: [],
    db_ctx_related_quotations: [],
    db_ctx_related_visits: [],
  },
  getters: {
    vSupplier(state) {
      return state.db_selection_supplier;
    },
    vSupplierProperty(state) {
      return state.db_selection_supplier_property;
    },
    vSupplierPropertyContact(state) {
      return state.db_selection_supplier_property_contact;
    },
    vSupplierBilling(state) {
      return state.db_selection_supplier_billing;
    },
    vSupplierBillingContact(state) {
      return state.db_selection_supplier_billing_contact;
    },
    vSupplierId(state) {
      return state.db_selection_supplier?.id;
    },
    vSupplierPropertyId(state) {
      return state.db_selection_supplier_property?.id;
    },
    vSupplierPropertyContactId(state) {
      return state.db_selection_supplier_property_contact?.id;
    },
    vSupplierBillingId(state) {
      return state.db_selection_supplier_billing?.id;
    },
    vSupplierBillingContactId(state) {
      return state.db_selection_supplier_billing_contact?.id;
    },
    vSupplierDialog(state) {
      return state.db_dialog;
    },
    vSupplierCreateDialog(state) {
      return state.db_create_dialog;
    },
    vSupplierLoading(state) {
      return state.db_selection_loading;
    },
    vRelatedSupplierInvoices(state) {
      return state.db_ctx_related_invoices;
    },
    vRelatedSupplierQuotations(state) {
      return state.db_ctx_related_quotations;
    },
    vRelatedSupplierVisits(state) {
      return state.db_ctx_related_visits;
    },
  },
  mutations: {
    [SET_SUPPLIER](state, payload) {
      state.db_selection_supplier = payload;
    },
    [SET_SUPPLIER_PROPERTY](state, payload) {
      state.db_selection_supplier_property = payload;
    },
    [SET_SUPPLIER_PROPERTY_CONTACT](state, payload) {
      state.db_selection_supplier_property_contact = payload;
    },
    [SET_SUPPLIER_BILLING](state, payload) {
      state.db_selection_supplier_billing = payload;
    },
    [SET_SUPPLIER_BILLING_CONTACT](state, payload) {
      state.db_selection_supplier_billing_contact = payload;
    },
    [SET_LOADING](state, payload) {
      state.db_selection_loading = payload;
    },
    [CLEAR_SUPPLIER](state) {
      state.db_selection_supplier = {};
      state.db_selection_supplier_property = {};
      state.db_selection_supplier_property_contact = {};
      state.db_selection_supplier_billing = {};
      state.db_selection_supplier_billing_contact = {};
    },
    [SET_SUPPLIER_RELATED](state, payload) {
      state.db_ctx_related_invoices = ObjPath.get(
        payload,
        "data.data.invoices",
        []
      );
      state.db_ctx_related_quotations = ObjPath.get(
        payload,
        "data.data.quotations",
        []
      );
      state.db_ctx_related_visits = ObjPath.get(
        payload,
        "data.data.visits",
        []
      );
    },
    [SET_DIALOG_STATUS](state, payload) {
      state.db_dialog = payload;
    },
    [SET_CREATE_DIALOG_STATUS](state, payload) {
      state.db_create_dialog = payload;
    },
  },
  actions: {
    [CLEAR_SUPPLIER](context) {
      context.commit(CLEAR_SUPPLIER);
    },
    [SET_SUPPLIER](context, payload) {
      return new Promise((resolve, reject) => {
        context.commit(SET_SUPPLIER, {});
        context.commit(SET_SUPPLIER_PROPERTY, {});
        context.commit(SET_SUPPLIER_PROPERTY_CONTACT, {});
        context.commit(SET_SUPPLIER_BILLING, {});
        context.commit(SET_SUPPLIER_BILLING_CONTACT, {});

        ApiService.setHeader();
        context.commit(SET_LOADING, true);

        ApiService.get(`supplier/${payload.id}`)
          .then((response) => {
            context.commit(
              SET_SUPPLIER,
              ObjPath.get(response, "data.data.supplier", {})
            );
            context.commit(
              SET_SUPPLIER_PROPERTY,
              ObjPath.get(response, "data.data.property", {})
            );
            context.commit(
              SET_SUPPLIER_PROPERTY_CONTACT,
              ObjPath.get(response, "data.data.property_contact_person", {})
            );
            context.commit(
              SET_SUPPLIER_BILLING,
              ObjPath.get(response, "data.data.billing", {})
            );
            context.commit(
              SET_SUPPLIER_BILLING_CONTACT,
              ObjPath.get(response, "data.data.billing_contact_person", {})
            );

            resolve(true);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            context.commit(SET_LOADING, false);
          });
      });
    },
    [SET_SUPPLIER_DATA](context, payload) {
      context.commit(
        SET_SUPPLIER,
        ObjPath.get(payload, "data.data.supplier", {})
      );
      context.commit(
        SET_SUPPLIER_PROPERTY,
        ObjPath.get(payload, "data.data.property", {})
      );
      context.commit(
        SET_SUPPLIER_PROPERTY_CONTACT,
        ObjPath.get(payload, "data.data.property_contact_person", {})
      );
      context.commit(
        SET_SUPPLIER_BILLING,
        ObjPath.get(payload, "data.data.billing", {})
      );
      context.commit(
        SET_SUPPLIER_BILLING_CONTACT,
        ObjPath.get(payload, "data.data.billing_contact_person", {})
      );
    },
    [GET_SUPPLIER_RELATED](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.query(`supplier-related/${payload.id}`, {
          "d-type": payload.type,
        })
          .then((response) => {
            context.commit(SET_SUPPLIER_RELATED, response);
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            context.commit(SET_LOADING, false);
          });
      });
    },
    [SET_LOADING](context, payload) {
      context.commit(SET_LOADING, payload);
    },
    [SET_DIALOG_STATUS](context, payload) {
      context.commit(SET_DIALOG_STATUS, payload);
    },
    [SET_CREATE_DIALOG_STATUS](context, payload) {
      context.commit(SET_CREATE_DIALOG_STATUS, payload);
    },
  },
};
